import type { IContractBook, SupportedChainId } from "@eulerxyz/core-sdk"
import { ContractFunctionConfig, EVCCall } from "@eulerxyz/evc-sdk"
import type { TransactionItemUnion, TransactionItems } from "./types"

export abstract class BaseTransactionFactory {
  chainId: SupportedChainId
  contractBook: IContractBook
  constructor(chainId: SupportedChainId, contractBook: IContractBook) {
    this.chainId = chainId
    this.contractBook = contractBook
  }

  abstract typeGuardConvertMultiple(
    transactions: TransactionItems,
  ): (ContractFunctionConfig | EVCCall)[]

  abstract typeGuardConvertSingle(
    transaction: TransactionItemUnion,
  ): ContractFunctionConfig | EVCCall

  errorUnsupportedTransactionType(transaction?: TransactionItemUnion): Error {
    return Error(
      `${
        this.constructor.name
      } | Unsupported transaction type: ${JSON.stringify(
        transaction,
        null,
        2,
      )}`,
    )
  }
}
